import client from 'data/client';
import { PaymentData } from 'data/types/payment';
import { normalizePayment } from 'model/payment';

const getPayment = async (brandId: string) => {
  const response = await client.get<PaymentData>(
    `reporting/payment?brandId=${brandId}`,
  );
  return normalizePayment(response.data);
};

export default getPayment;
